import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import moment from 'moment';
import { HistoryPanel } from './styled';
import { isEmpty } from 'lodash';
import tableColumnsIndex from './tableColumnsIndex';
import AlertHistoryTopPanel from './AlertHistoryTopPanel';
import {
  DEFAULT_WIDGET_TITLE,
  UNIFIED_ALERTS_SOURCE_IDS,
  DEFAULT_PAGINATION
} from './constants';
import { convertDateInputToEpoch } from '../../../util/timezone';

const AlertHistory = ({ apiActions, isLoading, alertHistory, customerId }) => {
  const [dateRange, setDateRange] = useState({
    startDate: moment().startOf('day').subtract(30, 'days').add(1, 'days'),
    endDate: moment().endOf('day')
  });
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [filterOption, setFilterOption] = useState({
    sourceIds: UNIFIED_ALERTS_SOURCE_IDS
  });

  const { getAMLSCommonUnifiedAlerts } = apiActions;

  useEffect(() => {
    if (!isEmpty(customerId)) {
      getAMLSCommonUnifiedAlerts({
        customerId: `${customerId},`,
        sourceIds: `${filterOption.sourceIds.join(',')},`,
        limit: pagination.pageSize,
        offset: (pagination.currentPage - 1) * pagination.pageSize,
        q: 'eyJzb3J0Ijp7fSwiZmlsdGVyIjpbXX0K',
        from: convertDateInputToEpoch(
          dateRange.startDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          true
        ),
        to: convertDateInputToEpoch(
          dateRange.endDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          true
        )
      });
    }
  }, [customerId, pagination, dateRange, filterOption]);

  const onPaginationChange = (page, pageSize) => {
    setPagination({
      pageSize,
      currentPage: page
    });
  };

  const onChangeWidgetAction = (values) => {
    const { from, to } = values;
    setPagination(DEFAULT_PAGINATION);
    setDateRange({ startDate: from.startOf('day'), endDate: to.endOf('day') });
  };

  const onFilterChangeAction = (sourceIds) => {
    setFilterOption({
      ...filterOption,
      sourceIds
    });
    setPagination(DEFAULT_PAGINATION);
  };

  const { payload = [], total = 0 } = alertHistory || {};

  return (
    <HistoryPanel>
      <AlertHistoryTopPanel
        widgetTitle={DEFAULT_WIDGET_TITLE}
        dateRange={dateRange}
        customerId={customerId}
        onChangeWidgetAction={onChangeWidgetAction}
        onFilterChangeAction={onFilterChangeAction}
        optedFilterOption={filterOption}
      />
      <Table
        dataSource={payload}
        columns={tableColumnsIndex}
        rowKey="alertId"
        loading={isLoading}
        pagination={{
          total,
          current: pagination.currentPage,
          onChange: onPaginationChange,
          pageSize: pagination.pageSize,
          showTotal: () => `${total} Records`,
          showSizeChanger: false
        }}
      />
    </HistoryPanel>
  );
};

AlertHistory.propTypes = {
  apiActions: PropTypes.object.isRequired,
  alertHistory: PropTypes.object,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  customerId: PropTypes.string.isRequired,
  mapNamespace: PropTypes.string
};

export default AlertHistory;
